import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Topbar from "./components/Topbar";
import Header from "./components/header";
import Privacy from "./components/privacy";
import About from "./components/about";
import Acgais from "./components/AcGasRefil";
import Acmainteain from "./screen/AC_Annual_Maintenance";
import Acinstallation from "./components/AcInstalltion";
import Acrepair from "./components/AcRepair";
import Acservice from "./components/AcService";
import Acunstill from "./components/AcUninstalltion";
import CassetteAC from "./components/Cassette_AC_Repair";
import Contact from "./components/Contact";
import Service from "./components/Service";
import Splitac from "./components/Split_AC_Repair";
import Windos from "./components/Window_AC_Repair";
import Callback from "./components/callback";

import Hero from "./screen/hero";
import Ourservice from "./screen/ourservice";
import Homeabout from "./screen/HomeAbout";
import Transfom from "./screen/transfom";
import Type from "./screen/typesac";
import Review from "./screen/review";
import Chooseus from "./screen/ChooseUs";
import Home from "./screen/home";
import Herolast from "./screen/herolast";
import Footer from "./screen/Footer";
import WashingMachineRepair from "./screen/WashingMachineRepair";
import WashingMachine from "./screen/WashingMachine";
import FloatingButtons from "./components/FloatingButtons"; // ✅ Added floating buttons
import ScrollToTop from "./components/ScrollToTop"; // ✅ Import ScrollToTop

function App() {
  return (
    <Router>
      <ScrollToTop />
      {/* Routes */}
      <Routes>
        <Route path="/hero" element={<Hero />} />
        <Route path="/topbar" element={<Topbar />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/acmaintain" element={<Acmainteain />} />
        <Route path="/acgais" element={<Acgais />} />
        <Route path="/acinstallation" element={<Acinstallation />} />
        <Route path="/acrepair" element={<Acrepair />} />
        <Route path="/acsrvice" element={<Acservice />} />
        <Route path="/acunstill" element={<Acunstill />} />
        <Route path="/cassetteAC" element={<CassetteAC />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service" element={<Service />} />
        <Route path="/splitac" element={<Splitac />} />
        <Route path="/windos" element={<Windos />} />

        <Route path="/ourservice" element={<Ourservice />} />
        <Route path="/homeabout" element={<Homeabout />} />
        <Route path="/transfom" element={<Transfom />} />
        <Route path="/type" element={<Type />} />
        <Route path="/review" element={<Review />} />
        <Route path="/choosus" element={<Chooseus />} />
        <Route path="/herolast" element={<Herolast />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/privacy"  element={<Privacy />} />
        <Route path="/washing-machine-service"  element={<WashingMachine />} />
      </Routes>

      {/* ✅ Floating Buttons (always visible on every page) */}
      <FloatingButtons />
    </Router>
  );
}

export default App;
